import React from "react";
import SocialMedia from "./SocialMedia";
import { useNewsletterForm } from "@wantable/Shared/Hooks";
import ErrorIcon from "./ErrorIcon";
import ArrowRight from "./ArrowRight";
import SuccessIcon from "./SuccessIcon";

const Newsletter = () => {
  const {
    email,
    updateEmail,
    sending,
    signToNewsletter,
    error,
    isEmailVaild,
    isSuccessfullySent,
  } = useNewsletterForm();

  return (
    <div>
      {
        //@ts-ignore
        window.WANTABLE_footer && window.WANTABLE_footer.title && (
          <p className="font-primary text-mobile-heading-6 lg:text-desktop-heading-6 font-bold mb-20 mt-32">
            {
              //@ts-ignore
              window.WANTABLE_footer.title
            }
          </p>
        )
      }
      <div className="w-full max-w-[384px] flex flex-col sm:mb-30">
        {isSuccessfullySent && (
          <p className={`opacity-100 flex items-center text-[14px] gap-x-[5px] text-[#25B900] w-full`}>
            <SuccessIcon />
            "You have successfully subscribed to the newsletter!"
          </p>
        )}
        <form
          onSubmit={signToNewsletter}
          className={`w-full flex justify-between ${
            error ? "border-b-red-error" : "border-b-black"
          } border-b-[1px]`}
        >
          <div className="w-full">
            <input
              className="w-full h-[37px] font-medium text-[14px] placeholder-black font-secondary"
              placeholder="Email address..."
              type="text"
              value={email}
              onChange={({ target }) => updateEmail(target.value.toLowerCase())}
              onBlur={isEmailVaild}
            />
          </div>
          <button disabled={sending} type="submit" className="h-[37px] px-10">
            <span className="flex flex-row font-bold items-center text-[15px] leading-[17px]">
              Submit
              <ArrowRight className="ml-[7px]" />{" "}
            </span>
          </button>
        </form>
        <p
          className={`${
            error ? "flex" : "hidden"
          } items-center text-[14px] gap-x-[5px] text-red-error w-full`}
        >
          <ErrorIcon />
          {error}
        </p>
      </div>
      {window && (
        <p className="mt-[13px] text-grey-600 font-medium text-[12px] font-secondary">
          {
            // @ts-ignore
            window.WANTABLE_footer.hint
          }
        </p>
      )}

      <div className="hidden md:flex md:mt-[15px]">
        <SocialMedia />
      </div>
    </div>
  );
};

export default Newsletter;
